'use client';

import flush from 'just-flush';
import { stepListSection } from '@stereoagency/sanity-schema';
import { StepListSection as UIStepListSection } from '@stereoagency/ui';
import { SimpleBlockContent } from '../sanity/client';

type Props = typeof stepListSection.schema.stepListSection;

export default function StepListSection({ title, cards }: Props) {
  if (!cards?.length) {
    return null;
  }

  return (
    <UIStepListSection
      title={title}
      cards={flush(
        cards.map((card, index) => {
          if (!card.title) {
            return null;
          }

          return {
            label: card.label ?? index + 1,
            title: card.title,
            description: card.description ? (
              <SimpleBlockContent value={card.description} />
            ) : null
          };
        })
      )}
    />
  );
}
